import React from "react"
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Button, Typography, DialogTitle } from '@material-ui/core'
import classNames from "classnames"
import useStyles from "./style.js"

const Newcard = ({ article:{description,publishedAt,source,title,url,urlToImage}, i ,activearticle}) => {
    const classes=useStyles();
    return (
        <Card className={classNames(classes.card,activearticle===i?classes.activeCard : null)}>
            <CardActionArea href={url} target="_black">
                <CardMedia className={classes.media} image={urlToImage || "https://media.gettyimages.com/vectors/breaking-news-vector-id1183566393?s=612x612"} />
                <div className={classes.details}>
                    <Typography variant="body2" color="textSecondary" component="h2">{(new Date(publishedAt)).toDateString()}</Typography>
                    <Typography variant="body2" color="textSecondary" component="h2">{source.name}</Typography>
                </div>
                <Typography gutterBottom variant="h5" className={classes.title}>{title}</Typography>
                <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">{description}</Typography>
                </CardContent>
            </CardActionArea>
            <CardActions className={classes.cardAction}>
                <Button size="small" color="primary">Learn More</Button>
                <Typography variant="h5" color="textSecondary">{i+1}</Typography>
            </CardActions>
        </Card>
    )
}
export default Newcard;